/**
 * 活动相关
 */
import * as ACTION from '../constants/types/activityTypes';
import { packageReq } from '../helpers/request';
import { packageObsoleteReq } from '../deconstructionCenter/obsoleteApi'


// 获取活动列表
export function getActivityList(){

	var payload = packageReq('GET_ACTIVITY_LIST', null, null, 'GET');

	return {
		type: ACTION.GET_ACTIVITY_LIST,
		payload
	}
};

// 获取活动详情
export function getActivityDetail(aid){
	
	var dirtyPayload = packageObsoleteReq('GET_ACTIVITY_DETAIL', [aid], null, 'GET');

	return {
		type: ACTION.GET_ACTIVITY_DETAIL,
		dirtyPayload
	}
};


// 参与活动
export function playActivity(aid){
	
	var dirtyPayload = packageObsoleteReq('PLAY_ACTIVITY', [aid], null, 'GET');

	return {
		type: ACTION.PLAY_ACTIVITY,
		dirtyPayload
	}
};

// 销毁当前活动数据
export function distroyActivityDetail() {
	return {
		type: ACTION.DISTROY_ACTIVITY_DETAIL
	}
}


